function fetchUser({ userId, ...query }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/users/${userId}`;
  return apiClient.get(route, { query });
}

export default {
  fetchUser
};



// WEBPACK FOOTER //
// ./app/api/UserApi.js